/**
 * Check whether or not a toast can be automatically dismissed.
 */
export var isDismissable = function isDismissable(dismissIn) {
  if (dismissIn === void 0) {
    dismissIn = 0;
  }

  return Number.isFinite(dismissIn) && dismissIn > 0;
};